/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { parse } from './parse';
import { tokenizer } from './tokenizer';
import { Translator } from './translator';

let APITranslator;
export const conditionSearch = (language, i18n): any => {
    APITranslator = new Translator(language);
    return (input): any => {
        try {
            const tokens = tokenizer(input);
            const AST = parse(tokens);
            return APITranslator.transform(AST, input, i18n);
        } catch (e) {
            return null;
        }
    };
};
export const generateTip = (input): any => {
    try {
        const tokens = tokenizer(input, false);
        const AST = parse(tokens, false);
        return APITranslator.generateTip(AST);
    } catch (e) {
        return undefined;
    }
};
